import { render, staticRenderFns } from "./AvailabilityForm.vue?vue&type=template&id=01a0d288"
import script from "./AvailabilityForm.vue?vue&type=script&lang=ts"
export * from "./AvailabilityForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports